<template>
  <div class="v-mission">
    <div class="header">
      <h2>{{$t('AboutText.p4_title')}}</h2>
    </div>
    <div class="content">
      <p>{{$t('AboutText.p4_content_1')}}</p>
      <p>{{$t('AboutText.p4_content_2')}}</p>
      <p>{{$t('AboutText.p4_content_3')}}</p>
      <p>{{$t('AboutText.p4_content_4')}}</p>
      <p>{{$t('AboutText.p4_content_5')}}</p>
    </div>
  </div>
</template>

<script>
    export default {
        name: "p4-mission"
    }
</script>

<style scoped lang="scss">
  .en  .v-mission{
    .content{
      width: 54.59vw;
      margin: 0 auto;
      p{
        font-size: 1.22vw;
        line-height: 2.66vw;
        text-align-last: justify;
        &:last-child{
          text-align-last: left;
        }
      }
    }
  }

  .v-mission{
    text-align: center;
    padding: 7.6vw 16vw 10.5vw 18.5vw;
    background: url('../../assets/images/about/p4.jpg') no-repeat;
    background-size: 100% 100%;
    .header{
      margin-bottom:  5vw;
      h2{
        font-size: 3.13vw;
        font-weight: bold;
      }
    }
    .content{
      width: 54.59vw;
      margin: 0 auto;
        p{
          font-size: 1.22vw;
          line-height: 2.66vw;
          text-align: center;
        }
    }
  }
</style>




// WEBPACK FOOTER //
// src/view/about/p4-mission.vue